import { put, takeLatest, call } from "redux-saga/effects";
import * as memberType from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import * as Api from "../../../appApi/AppApi";
import { createActionOf } from "../../actions/ActionCreator";

const TAG = "getAllUsersAdminPortalSaga.js";

function* workerGetAllUseresAdminPortal(payLoad) {
  console.log(TAG, "get all Users : " + JSON.stringify(payLoad));
  try {
    const response = yield call(
      Api.makeSecuredGetRequest,
      API_ENDPOINT.GET_ALL_USERS_ADMIN_PORTAL
    );
    console.log('respo in getallusersadminportal saga :',response);
    yield put(createActionOf(memberType.GET_ALL_USERS_SUCCESS_ADMIN_PORTAL, 1, response))
  } catch (error) {
    console.error(TAG, "Worker get All Users failed: " + error.message);
    yield put(createActionOf(memberType.GET_ALL_USERS_FAILED_ADMIN_PORTAL,2, error));
    // throw new Error("Error: inside saga", JSON.stringify(error));
  }
}

export const watchGetAllUsersAdminPortal = takeLatest(
  memberType.GET_ALL_USERS_REQUESTED_ADMIN_PORTAL,
  workerGetAllUseresAdminPortal
);
